export default "__VITE_ASSET__CGLvexSF__"